module.exports = __webpack_public_path__ + "img/bar-chart-square-up.5d50a182.svg";